<template>
  <div class="software-select">
    <v-select
      ref="select"
      :taggable="canCreate"
      :filterable="false"
      :closeOnSelect="false"
      :options="results"
      @search="search"
      @input="select"
      @keyup.native="handleEmptySearch"
      :placeholder="placeholder">
      <template slot="no-options">
        Search software...
      </template>
    </v-select>

    <ul class="software-list">
      <li v-for="(software, index) in value">
        <button
          class="delete-btn"
          @click.prevent="deselect(index)">
          <i class="fa fa-times"></i>
        </button>

        <software-item :software="software">
        </software-item>
      </li>
    </ul>
  </div>
</template>

<script>
  import SoftwareItem from '../software-item';

  export default {
    name: 'software-select',

    components: { SoftwareItem },

    props: {
      placeholder: {
        type: String,
        default: 'Example'
      },
      options: {
        type: Array,
        // [ { id, name, iconUrl } ]
      },
      canCreate: {
        type: Boolean,
        default: false
      },
      value: {
        type: Array,
        // [ { id, name, iconUrl } ]
        // This component also emits 'input' events, which means v-model is
        // supported.
      }
    },

    data() {
      return {
        results: [],
      };
    },

    methods: {
      reset() {
        this.$refs.select.deselect();
        this.results = [];
        this.$emit('input', []);
      },

      select(option) {
        if (!option) {
          return;
        }

        // Clear the v-select value
        this.$refs.select.deselect();

        // Clear the search results
        this.results = [];

        // Non-existing software will (usually) come in as a plain string
        if (typeof option === 'string') {
          option = {
            id: null,
            iconUrl: null,
            label: option.trim(),
            name: option.trim()
          };
        }

        // For some reason, some options come in just as { label: ... }
        option.id = option.id || null;
        option.iconUrl = option.iconUrl || null;
        option.label = option.label.trim();
        option.name = option.name.trim() || option.label;

        // If this is a new option, do a lowercase comparison with existing
        // options so that we don't create an option like "maya" when "Maya"
        // already exists.
        const lcSearchTerm = option.name.toLowerCase();
        for (const existingOption of this.options) {
          const matches = existingOption.name.toLowerCase().includes(lcSearchTerm);
          if (matches) {
            option = existingOption;
            break;
          }
        }

        // Check if this option was already selected
        let selected = false;
        if (option.id) {
          selected = !!this.value.find(o => {
            return o.id === option.id;
          });
        } else {
          selected = !!this.value.find(o => {
            return o.name.toLowerCase() === option.name.toLowerCase();
          });
        }
        if (selected) {
          return;
        }

        // Save the option
        const newValue = this.value.concat([{
          id:      option.id,
          name:    option.name,
          iconUrl: option.iconUrl
        }]);
        this.$emit('input', newValue);
      },

      deselect(index) {
        const newValue = this.value.filter((v, i) => i !== index);
        this.$emit('input', newValue);
      },

      search(searchTerm, setLoading) {
        setLoading(true);
        const lcSearchTerm = searchTerm.toLowerCase().trim();
        const newResults = [];
        for (const option of this.options) {
          const matches = option.name.toLowerCase().includes(lcSearchTerm);
          if (matches) {
            newResults.push({
              id:      option.id,
              name:    option.name,
              iconUrl: option.iconUrl,
              label:   option.name
            });
          }
        }
        this.results = newResults;
        setLoading(false);
      },

      handleEmptySearch(ev) {
        // search() is only called when the search term is non-empty (this is a
        // known bug in the library); this method should check for an empty
        // search string and clear the results when found.
        if (ev.target.value.length === 0) {
          this.results = [];
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  .v-select {
    border-bottom: 1px solid #fff;
    font-family: inherit;
  }

  .software-list {
    margin-top: 10px;

    > li {
      display: inline-block;
      padding: 10px 5px;
      position: relative;
      vertical-align: top;

      .delete-btn {
        border: none;
        background: none;
        padding: 0;
        color: #2eb8e6; // #33ccff * 0.9
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;

        &:hover {
          background-color: rgba(16, 16, 16, 0.75);
          i {
            visibility: visible;
          }
        }

        i {
          font-size: 48px;
          width: 48px;
          visibility: hidden;
        }
      }
    }
  }
</style>

<style lang="scss">
  .software-select {
    .v-select {
      input {
        border-bottom: none !important;
      }
      .selected-tag {
        color: #ededed;
      }
      .dropdown-toggle {
        border: none;
      }
      .dropdown-menu {
        background-color: #363636;
        border: 1px solid #666;
        padding: 0;
        overflow-y: auto;
        max-height: 200px;
        li a {
          color: #ebebeb;
        }
        li.highlight a {
          color: white;
        }
      }
      .clear {
        color: #555;
      }
      .open-indicator::before {
        border-color: #b0b0b0;
      }
      .spinner {
        border-top-color: rgba(255, 255, 255, 0.2);
        border-right-color: rgba(255, 255, 255, 0.2);
        border-bottom-color: rgba(255, 255, 255, 0.2);
        border-left-color: rgba(51, 204, 255, 0.65);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// index.vue?20203470